/* eslint-disable import/no-extraneous-dependencies */
import React, { Component, PropTypes } from 'react'
import { isEmpty } from 'lodash/lang'
import { connect } from 'react-redux'
import { reduxForm } from "redux-form"
import { fetchFinances } from 'state/actions'
import { DatePicker } from 'components/shared/datePicker'
import { FormField } from 'components/shared/form-field'
import Input from 'components/input'
import Documents from './FinancesDocuments'
import Transactions from './FinancesTransactions'
import SelectWrapper from 'components/shared/select/SelectWrap'
import translate from '../translation'
import styles from './Finances.scss'

@reduxForm({
	form: 'finances',
	fields: ['startDate', 'endDate', 'contractNumber', 'type'],
	initialValues: {
		startDate: '',
		endDate: '',
		contractNumber: '',
		type: 'b', // default value for type is 'b' (all)
	},
})
@connect(({ app, finances }) => ({
	items: finances.items,
	documents: finances.documents,
	summary: finances.summary,
	brNr: app.brNr,
}))
export class Finances extends Component {
	constructor(props) {
		super(props)
		const options = [
			{ value: 't', label: translate('transacties') },
			{ value: 'd', label: translate('documenten') },
			{ value: 'b', label: translate('all') },
		]
		this.state = {
			msgHidden: true,
			activeTab: isEmpty(props.documents) ? 't' : 'd',
			options,
		}
	}

	handleTabChange(activeTab) {
		this.setState({ activeTab })
	}

    saveForm(data) {
        const { dispatch, brNr } = this.props
        const { msgHidden } = this.state
        data.brokerNumber = brNr

        if (!msgHidden) {
            this.setState({ msgHidden: true })
        }

        dispatch(fetchFinances(data))
        .then(res => {
            const activeTab = data.type === 'b' ? 't' : data.type // if type is 'b' (all) then show transactions, else show the type (e.g. 't' for transactions, 'd' for documents)
            this.setState({ msgHidden: false, activeTab })

            return res
        })
		.catch(err => {
            this.setState({ msgHidden: false, activeTab: 't' })

            return err
        })
    }

	render() {
		const { msgHidden, activeTab, options } = this.state
		const { fields, handleSubmit, documents, items, summary } = this.props
		const { startDate: startDateField, endDate: endDateField, contractNumber: contractNumberField, type: typeField } = fields

		return (
			<div className={styles.officeFinances}>
				<form onSubmit={handleSubmit(this.saveForm.bind(this))}>
					<div className={styles.submitContainer}>
						<FormField label={translate('from')} field={startDateField} className={styles.inputContainer}>
							<DatePicker
								id={translate('from')}
								name={translate('from')}
								className={styles.inputForm}
								{...startDateField}
								startDate={startDateField.value}
								endDate={endDateField.value}
							/>
						</FormField>
						<FormField label={translate('to')} field={endDateField} className={styles.inputContainer}>
							<DatePicker
								id={translate('to')}
								name={translate('to')}
								className={styles.inputForm}
								{...endDateField}
								startDate={startDateField.value}
								endDate={endDateField.value}
							/>
						</FormField>
						<FormField label={translate('policy')} field={contractNumberField} className={styles.inputContainer}>
							<Input
								type="text"
								id={translate('policy')}
								name={translate('policy')}
								className={styles.inputForm}
								value={contractNumberField.value}
								onChange={contractNumberField.onChange} // eslint-disable-line react/jsx-handler-names
							/>
						</FormField>
						<FormField label={translate('type')} field={typeField} className={styles.inputContainer}>
							<SelectWrapper
								isClearable={false}
								id={translate('type')}
								name={translate('type')}
								options={options}
								value={typeField.value}
								onChange={typeField.onChange} // eslint-disable-line react/jsx-handler-names
								className={styles.inputForm}
							/>
						</FormField>
						<button type="submit" className={styles.submitButton}>{translate('search')}</button>
					</div>
				</form>
				{(!isEmpty(items) || !isEmpty(documents)) ?
					<div className={styles.results}>
						<div className={styles.subNavigationCont}>
							<div className={styles.subNav}>
                                {!isEmpty(items) && (
									<div className={styles.catCont}>
										<a
											onClick={this.handleTabChange.bind(this, 't')}
											className={activeTab === "t" ? `${styles.active}` : `${styles.inactive}`}
										>
											{translate('transacties')}
										</a>
									</div>
								)}
								{!isEmpty(documents) && (
									<div className={styles.catCont}>
										<a
											onClick={this.handleTabChange.bind(this, 'd')}
											className={activeTab === "d" ? `${styles.active}` : `${styles.inactive}`}
										>
											{translate('documenten')}
										</a>
									</div>
								)}
							</div>
						</div>
						{activeTab === "t" ?
							<Transactions items={items} summary={summary}/> :
							<Documents docs={documents}/>
						}
					</div> :
					(Boolean(msgHidden) || <p>{translate('polisError')}</p>)
				}
			</div>
		)
	}
}
Finances.propTypes = {
	dispatch: PropTypes.func,
	brNr: PropTypes.string,
	fields: PropTypes.object,
	handleSubmit: PropTypes.func,
	documents: PropTypes.arrayOf(PropTypes.object),
	items: PropTypes.arrayOf(PropTypes.object),
	summary: PropTypes.object,
}




// WEBPACK FOOTER //
// ./components/office/finances/Finances.jsx